// Design Wars: Pop-in on scroll (left/right)
(function () {
  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReduced) return;

  const makeRevealTargets = () => {
    const selectors = [
      '.product-grid .grid__item',
      '.collection .grid__item',
      'ul.grid li.grid__item',
      '.multicolumn-list__item',
      '.rich-text',
      '.image-with-text',
      '.collage__item',
      '.dw-story__wrap',
      '.collection-list__item'
    ];
    const nodes = new Set();
    selectors.forEach(sel => document.querySelectorAll(sel).forEach(n => nodes.add(n)));
    // Add reveal class if not already
    [...nodes].forEach((el, idx) => {
      if (!el.classList.contains('dw-reveal')) el.classList.add('dw-reveal');
      // alternate direction
      el.classList.toggle('dw-reveal--right', idx % 2 === 1);
    });
    return [...nodes];
  };

  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

  const targets = makeRevealTargets();
  targets.forEach(t => io.observe(t));

  // If Shopify loads sections dynamically
  document.addEventListener('shopify:section:load', () => {
    makeRevealTargets().forEach(t => io.observe(t));
  });
})();
